import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=fc2a8738&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"
import style1 from "./Blog.vue?vue&type=style&index=1&id=fc2a8738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2a8738",
  null
  
)

export default component.exports